export default __webpack_public_path__ + "static/media/user-default-log.78b64d9f.svg";